module.exports = require('./helpers/bundle-url').getBundleURL('9NmXR') + "logo-dark.eefe0b7f.svg";